/** Felt for gaver rett i appen (Vipps/Stripe på moskeens egen konto). */
export interface CampaignPaymentFields {
  stripeEnabled?: boolean;
  vippsEnabled?: boolean;
  monthlyEnabled?: boolean;
  oneTimeEnabled?: boolean;
  /** Forslag til beløp i kroner. */
  suggestedAmounts?: number[] | null;
  /** Read-only fra serveren: aktivert på kampanjen OG tilkoblet hos moskeen. */
  donationProviders?: string[] | null;
}

export const MIN_AMOUNT = 10;
export const MAX_AMOUNT = 100000;

/** «100, 200 500» → [100, 200, 500]. Gir null hvis noe ikke er et gyldig beløp. */
export const parseAmounts = (text: string): number[] | null => {
  const parts = text
    .split(/[\s,;]+/)
    .map((p) => p.trim())
    .filter(Boolean);
  const amounts: number[] = [];
  for (const part of parts) {
    if (!/^\d+$/.test(part)) return null;
    const amount = Number(part);
    if (amount < MIN_AMOUNT || amount > MAX_AMOUNT) return null;
    if (!amounts.includes(amount)) amounts.push(amount);
  }
  return amounts;
};

export const formatAmounts = (amounts?: number[] | null) =>
  (amounts ?? []).join(", ");

export const providerLabel = (provider: string) =>
  provider === "VIPPS"
    ? "Vipps"
    : provider === "STRIPE"
      ? "Kort (Stripe)"
      : provider;
